import * as React from 'react';
import {observer} from "mobx-react"
import '../index.css';
import '../../images/lager_1.png';
import '../../images/lager_2.png';
import '../../images/lager_3.png';
import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";



@observer
export default class Lager extends React.Component {



    render()
    {

        return (
            <div>
                <div className="header_Verkauf">
                    <div className="header_openHours_text">Ersatzteillager</div>
                    <div className="header_openHours_body">Ersatzteile - Zubehör</div>
                </div>
                <div className="textVerkauf">
                    <div className="paragraphModal">
                        Wir bieten Ihnen einen umfangreichen Ersatzteilbestand für die von uns im Programm geführten Landmaschinenmarken, und die Beschaffung
                        sämtlicher Ersatzteile und Zubehör für Landmaschinen und landwirtschaftliche Fahrzeugen aller Marken bis hin zum „ Oldie „ - in kürzester Zeit.
                        Unser ET-Team ist ständig bemüht , dringende Ersatzteile für Sie zu besorgen.
                    </div>
                    <div className="paragraphModal">
                        Zusätzlich ist unser Standort Zentrallager für Rapid Ersatzteile.
                    </div>


                </div>
                <div className="wrapper">
                    <div className="root">
                        <GridList cellHeight={250}  spacing={30} className="gridList_Werkstatt" cols={3}>
                            <GridListTile key={"1"}>
                                <div className="container container_no_padding">
                                    <img src="./images/lager_1.png"
                                         alt="abc" className="imageFull"/>
                                </div>
                            </GridListTile>
                            <GridListTile key={"2"}>
                                <div className="container container_no_padding">
                                    <img src="./images/lager_2.png"
                                         alt="abc" className="imageFull"/>
                                </div>
                            </GridListTile>
                            <GridListTile key={"3"}>
                                <div className="container container_no_padding">
                                    <img src="./images/lager_3.png"
                                         alt="abc" className="imageFull"/>
                                </div>
                            </GridListTile>
                        </GridList>
                    </div>
                </div>
            </div>

        );

    }


}


